import {
    CHANGE_AUTH,
    REST_API,
    EYM_TKN,
    EYM_TKN_OBJ,
    EYM_USR,
    GET_METHOD,
    POST_METHOD,
    PATCH_METHOD,
    DELETE_METHOD
} from './constants'


export function sendMethod(token,body)
{
    return dispatch => {
        return fetch(`${REST_API}/tasks/test-publish?access_token=${token}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }).then(response => {
            // console.log("response",response)

            return response
        })
        // .then(json =>{
        //     console.log("JSON",json)
        //     return json
        // })

        
    }
}



// WEBPACK FOOTER //
// ./src/actions/devTools.js